import { render, staticRenderFns } from "./fileEdit.vue?vue&type=template&id=36b15e46&"
import script from "./fileEdit.vue?vue&type=script&lang=js&"
export * from "./fileEdit.vue?vue&type=script&lang=js&"
import style0 from "./fileEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports